import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const FORESTRYSTATUS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ForestryStatus.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ForestryStatus.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const FORESTRYSTATUS_CONFIG = {
  entityName: 'ForestryStatus',
  localizationKey: 'Planning::Entity.ForestryStatus',
  fields: FORESTRYSTATUS_FIELDS,
  permission: 'PlanningOperation.ForestryStatus',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
